import { AutoPublishState } from '../store/schema/BookWithMeOrganizerStore';
import store from '../store/Store';
import getFirstTimeUser from './getFirstTimeUser';

/*
 *   Selector to see if the autopublish is complete
 * if they are not a new user it is safe to assume the process has been done
 * if they are a new user we need to check the state of newUserAutoPublishState
 */

export default function isAutoPublishComplete(): boolean {
    let isComplete = true;
    if (getFirstTimeUser() && store.newUserAutoPublishState === AutoPublishState.Pending) {
        isComplete = false;
    }
    return isComplete;
}
